import type { MyIpProfile } from './types';

/** profile 属开放对象，已知字段也必须防御历史或 Agent 返回的非文本值。 */
function text(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/** 将新旧人设字段映射到只读展示，不改写或裁剪原始 profile。 */
export function getMyIpProfileDisplay(profile: MyIpProfile) {
  const setting = profile.character_setting && typeof profile.character_setting === 'object'
    ? profile.character_setting : {};
  const personality = Array.isArray(setting.personality)
    ? setting.personality.filter((item): item is string => typeof item === 'string' && Boolean(item.trim()))
    : [];
  const persona = text(profile.persona);
  return {
    identity: text(setting.identity),
    appearance: text(setting.appearance),
    visualStyle: text(profile.visual_style),
    persona,
    personality: personality.length ? personality : [persona].filter(Boolean),
    speechStyle: typeof profile.language_style === 'string' ? profile.language_style : text(setting.speech_style),
    backstory: text(setting.backstory),
    moreSettings: Array.isArray(profile.more_settings) ? profile.more_settings.filter(
      (item): item is { key: string; value: string; } => Boolean(item && typeof item === 'object'
        && typeof item.key === 'string' && typeof item.value === 'string'),
    ) : [],
  };
}
